<template>
    <v-app id="app" class="padding-h-m">
        <div class=" d-flex flex-column w-100">
            <div class="d-flex align-items-center justify-content-between cts-header">
                <div class="d-flex align-center" style="gap: 1rem;">
                    <img class="cts-logo" style="padding: 0rem 0; width: 150px; mix-blend-mode: darken"
                         :src="'/assets/images/logos/' + client_logo_name"
                         :alt="constants.client_version_Id" />
                </div>
                <div class="d-flex gap-3">
                    <!--System Notifications button-->
                    <v-btn id="red-notif-btn"
                           style="padding:0; width:40px;"
                           class="dgs-new-button-inner p-0 d-none d-md-block"
                           v-on:click="OpenSystemNotificationsDialog">
                        <v-icon :color="this.systemNotificationList.filter(x => x.isRead == false)?.length > 0 ? 'red' : '#024976'">
                            {{ this.systemNotificationList.filter(x => x.isRead == false)?.length > 0 ? 'mdi-bell-ring' : 'mdi-bell-outline' }}
                        </v-icon>
                    </v-btn>

                    <!--Public Announcements button-->
                    <v-btn v-if="enablePublicAnnouncements" id="red-notif-btn" style="padding:0; width:40px;"
                           class="dgs-new-button-inner p-0 d-none d-md-block"
                           v-on:click="OpenPublicAnnouncementssDialog">

                        <v-icon :color="this.publicAnnouncementsList?.length > 0 ? 'red' : '#024976'">
                            {{ this.publicAnnouncementsList?.length > 0 ? 'mdi-message-alert' : 'mdi-message-alert-outline' }}
                        </v-icon>
                    </v-btn>

                    <!-- lang switch btn -->
                    <div style="text-align: center;" class="language-switcher">
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(true)" v-if="isLanguageEn"
                               class="dgs-new-button-inner language-switcher__button">
                            <v-icon color="#024976"> mdi-abjad-arabic </v-icon>
                        </v-btn>
                        <v-btn style="padding:0; width:40px;" @click="changeRTL(false)" v-if="!isLanguageEn"
                               class="dgs-new-button-inner language-switcher__button">
                            <v-icon color="#024976"> mdi-abugida-devanagari </v-icon>
                        </v-btn>
                    </div>

                    <v-btn class="user-btn d-none d-md-block" v-on:click="openProfileBox"
                           v-if="constants.client_version_Id == 'DGS'">
                        <v-avatar class="sidebar-image m-0 " color="#eff2f5" size="43">
                            <span v-if="this.userAbbreviationSrc === ''" style="font-size:1.3rem">
                                {{this.userAbbreviation}}
                            </span>
                        </v-avatar>
                    </v-btn>
                    <v-menu offset-y content-class="mt-0" v-if="hasPermission('CreateOutgoingByFile')
                                || hasPermission('CreateOutgoing')
                                || ( isCircularEnabled && hasPermission('CreateCircular') )
                                || ( isDecreeEnabled && hasPermission('CreateDecree') )">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="menu-toggle-btn btn-add d-none d-md-block" color="primary" v-bind="attrs"
                                   v-on="on">
                                <span>{{ $t("res_MenuItems_CreateNew") }}</span>
                                <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-if="hasPermission('CreateIncoming')" @click="openCreateIncomingPopup">
                                <v-list-item-title>{{ $t("res_MenuItems_CreateIncoming") }}</v-list-item-title>
                            </v-list-item>
                            <v-menu content-class="align-bottom-left1" :left="isLanguageEn" :right="!isLanguageEn"
                                    top offset-x offset-y
                                    v-if="(hasPermission('CreateOutgoingByFile') && hasPermission('CreateOutgoing')) ">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">
                                        {{ $t("res_MenuItems_Outgoing") }}
                                        <v-icon>mdi-chevron-down</v-icon>
                                    </v-list-item>
                                </template>
                                <v-list>
                                    <v-list-item v-if="hasPermission('CreateOutgoingByFile')"
                                                 @click="openCreateOutgoingAttachPopup">
                                        {{
 $t("res_MenuItems_ByFile")
                                        }}
                                    </v-list-item>
                                    <v-list-item v-if="hasPermission('CreateOutgoing')"
                                                 @click="openCreateOutgoingPopup('')">
                                        {{$t("res_MenuItems_ByTemplate") }}
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-list-item @click="openCreateOutgoingPopup('')" class="justify-content-between"
                                         v-if="(!hasPermission('CreateOutgoingByFile') && hasPermission('CreateOutgoing'))">
                                <v-list-item-title>{{ $t("res_MenuItems_Outgoing") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isCircularEnabled && hasPermission('CreateCircular')"
                                         @click="openCreateOutgoingPopup('5')">
                                <v-list-item-title>{{ $t("res_MenuItems_Circular") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isDecreeEnabled && hasPermission('CreateDecree')"
                                         @click="openCreateOutgoingPopup('4')">
                                <v-list-item-title>{{ $t("res_MenuItems_Decree") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isContarctEnabled && hasPermission('CreateContract')"
                                         @click="openCreateOutgoingPopup('10')">
                                <v-list-item-title>{{ $t("res_MenuItems_Contract") }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu :left="isLanguageEn" :right="!isLanguageEn" offset-x offset-y :close-on-click="true"
                            :close-on-content-click="false" :value="shown"
                            content-class="sm-full-view filter ml-2rem p-0 py-1 px-1" v-if="$vuetify.breakpoint.smAndDown">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="btn-sm" color="white" v-bind="attrs" :ripple="false" v-on="on"
                                   @click="shown = true">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                        </template>

                        <div class="pt-4 cts-sheet cts-drawer">
                            <v-btn class="close-btn light-btn float-right sm-screen" icon @click="shown = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <div class="flex-1 px-3">
                                <div class="pt-4">
                                    <div v-for="(item, i) in constants.userActions.menu.filter(x=>x.icon != null && x.icon != '' && !showInProfileMenus.includes(x.menuItems.to.toLowerCase()))"
                                         :key="i" class="mb-3 border-bottom py-md-4 py-2 px-2 px-md-8">
                                        <router-link :to="item.menuItems.to" @click.native="shown = false"
                                                     :class="item.menuItems.class + (item.menuItems.to.toLowerCase() == '/inbox' ? (hasUnOpenedDocuments ? ' red-noti' : '') : '')"
                                                     active-class="active" class="text-decoration-none">
                                            <v-icon class="me-2">{{ item.icon }}</v-icon>
                                            <span>{{ $t(item.menuItems.labelText) }}</span>

                                            <v-badge v-if="getCount(item.menuItems.to.toLowerCase()) !== 0"
                                                     color="red" :content="getCount(item.menuItems.to.toLowerCase())"
                                                     inline></v-badge>
                                        </router-link>
                                    </div>
                                    <div class="mb-3 border-bottom py-md-4 py-2 px-2 px-md-8">
                                        <a class="text-decoration-none position-relative" @click="manageUserSignaturesDialog = true">
                                            <i class="v-icon notranslate me-2 mdi mdi-manage-signature theme--light"></i>
                                            <span>{{ $t("res_Label_ManageSignatures") }}</span>
                                        </a>
                                    </div>
                                    <div class="mb-3 border-bottom py-md-4 py-2 px-2 px-md-8" v-if="!constants.isFullAdmin">
                                        <a class="text-decoration-none position-relative" @click="openChangePinCode">
                                            <v-icon class="me-2">mdi-pin-code</v-icon>
                                            <span>{{ $t("res_MenuItems_ChangePinCode") }}</span>
                                        </a>
                                    </div>
                                    <div class="w-100 d-flex justify-content-center align-items-center">
                                        <v-btn class="mb-3 line-height-20" color="primary" width="100px" height="40px" @click="logout()">
                                            {{ $t("res_MenuItems_Logout") }}
                                        </v-btn>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </v-menu>

                </div>
            </div>
            <div class="d-flex w-100 ">
                <div class="sidebar margin-right-m">
                    <v-btn class="user-btn margin-top-l" v-on:click="openProfileBox"
                           v-if="constants.client_version_Id != 'DGS'">
                        <v-avatar class="sidebar-image m-0 " color="#eff2f5" size="43">
                            <img v-if="userProfileImage.data" :src="profileImage"
                                 style="width: 50px; height: 50px; border-radius: 50%;">
                            <span v-else>{{ this.userAbbreviation }}</span>
                        </v-avatar>
                    </v-btn>

                    <div class="mt-4 overflow-auto nodes-routes"
                         v-if="constants.userActions.menu">
                        <div v-for="(item,i) in constants.userActions.menu.filter(x=>x.icon != null && x.icon != '' && !showInProfileMenus.includes(x.menuItems.to.toLowerCase()))"
                             :key="i">
                            <!-- class,icon,labelText -->
                            <router-link v-if="['/inbox', '/draft', '/sent', '/followup', '/archive', '/cced', '/inbox-user' , '/inbox-structure'].includes(item.menuItems.to.toLowerCase())"
                                         active-class="active" :to="item.menuItems.to"
                                         :class="item.menuItems.class + (item.menuItems.to.toLowerCase() == '/inbox'? (hasUnOpenedDocuments?' red-noti':''):'')">
                                <v-badge color="red" style="position:absolute;z-index:90000"
                                         :content="getCount(item.menuItems.to.toLowerCase())"
                                         v-if="getCount(item.menuItems.to.toLowerCase()) !== 0" inline></v-badge>
                                <v-icon> {{ item.icon }} </v-icon>
                                <label class="mb-2"> {{ $t(item.menuItems.labelText) }} </label>
                            </router-link>
                            <router-link v-else active-class="active" :to="item.menuItems.to"
                                         :class="item.menuItems.class">
                                <v-icon> {{ item.icon }} </v-icon>
                                <label class="mb-2">{{ $t(item.menuItems.labelText) }}</label>
                            </router-link>
                        </div>
                        <div v-if="showAppSwitchButton">
                            <v-menu offset-y content-class="mt-0">
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <v-icon color="#024976">mdi-bell-outline</v-icon>
                                        <label class="mb-2">Switch</label>
                                    </div>
                                </template>
                                <v-list>
                                    <v-list-item @click="setDefaultApplication(1)"
                                                 v-if="this.defaultApplicationId != 1 && availableApplications.includes(1)">
                                        <v-list-item-title>CTS</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="setDefaultApplication(2)"
                                                 v-if="this.defaultApplicationId != 2 && availableApplications.includes(2)">
                                        <v-list-item-title>TMS</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="setDefaultApplication(3)"
                                                 v-if="this.defaultApplicationId != 3 && availableApplications.includes(3)">
                                        <v-list-item-title>MMS</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                </div>
                <router-view class="w-100" />
            </div>
        </div>


        <v-dialog v-model="profileDialog" content-class="profile-dialog m-0" width="420px">
            <v-card style="padding-bottom: 0px">
                <v-card-title class="p-0" style="margin-bottom: 1.75rem; line-height: 1.5rem">
                    {{ $t("res_DialogHeaders_Profile") }}
                </v-card-title>
                <v-card-text>
                    <div v-if="availableApplications.includes(1)">
                        <v-label>{{ $t("res_Msgs_SelectDefualtStructure") }}</v-label>
                        <div v-if="all_user_structures">
                            <multi-select class="light-bg" v-model="user_structure" label="structureName"
                                          track-by="structureId" open-direction="bottom" :options="all_user_structures"
                                          :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                                          :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false" :allow-empty="false"
                                          :hide-selected="false" :multiple="false" @input="userStructureChanged"
                                          :placeholder="$t('res_Label_SelectOption')">
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </multi-select>
                        </div>
                    </div>
                    <div class="mt-3 d-flex align-items-center">
                        <label>{{ $t("res_UserLoginTitle") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.loginName }}</label>
                        <span class="mdi mdi-content-copy copy-icon ms-auto" v-if="loginName" @click.stop="utils.copyToClipboard(loginName, 'res_Msgs_EmailCopied')" v-tooltip="$t('res_Label_CopyEmail')"></span>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t("res_Label_Role") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.RoleName }}</label>
                    </div>
                    <div class="mt-3">
                        <label>{{ $t("res_Title_Designation") }}: &nbsp;</label>
                        <label style="font-weight: 500">{{ this.profession }}</label>
                    </div>
                    <div class="mt-3">
                        <div>
                            <v-btn small class="light-blue" @click="openAddTransferFavorite">
                                {{ $t("res_MenuItems_ManageTransferFavorites") }}
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
                <div v-if="availableApplications.includes(1)">
                    <v-divider></v-divider>
                    <nav>
                        <div class="row d-flex justify-content-center" v-if="constants.userActions.menu">
                            <div v-if="hasPermission('ManageSignatures')"
                                 class="col-3 profile-icons-container profileIconsCustom"
                                 @click="manageUserSignaturesDialog = true">
                                <a><v-icon>mdi-manage-signature</v-icon></a>
                                <label>{{ $t("res_Label_ManageSignatures") }}</label>
                            </div>
                            <div v-if="!constants.isFullAdmin"
                                 class="col-3 profile-icons-container profileIconsCustom" @click="openChangePinCode">
                                <a><v-icon>mdi-pin-code</v-icon></a>
                                <label>{{ $t("res_MenuItems_ChangePinCode") }}</label>
                            </div>
                            <div v-if="!constants.isFullAdmin"
                                 class="col-3 profile-icons-container profileIconsCustom" @click="openDefaultSignerMethod">
                                <a><v-icon style="color: #204a75">mdi-signature-freehand</v-icon></a>
                                <label>{{ $t("res_Label_DefaultSignMethod") }}</label>
                            </div>
                            <div class="col-3 profile-icons-container profileIconsCustom"
                                 v-if="hasPermission('ManageExternalEntities')" @click="openManageExternalEntities">
                                <a><v-icon>mdi-sitemap-outline</v-icon></a>
                                <label>{{ $t("res_Label_ManageExternalEntities") }}</label>
                            </div>
                            <div class="col-3 profile-icons-container"
                                 v-for="(item,i) in constants.userActions.menu.filter(x=>x.icon != null && x.icon != '' &&  showInProfileMenus.includes(x.menuItems.to.toLowerCase()))"
                                 :key="i">
                                <!-- class,icon,labelText -->
                                <router-link class="profile-icons profileIconsCustom"
                                             @click.native="profileDialog=false" active-class="active" :to="item.menuItems.to"
                                             :class="item.menuItems.class">
                                    <!-- v-else-if="!['/reports', '/dashboard', '/delegation', '/admin'].includes(item.menuItems.to.toLowerCase())" -->
                                    <v-icon> {{ item.icon }} </v-icon>
                                    <label>{{ $t(item.menuItems.labelText) }}</label>
                                </router-link>
                            </div>
                        </div>
                    </nav>
                </div>
                <v-divider></v-divider>
                <v-card-actions class="p-0 d-flex justify-space-between align-center">
                    <div>
                        <label>{{ $t("res_Label_ServerName") }}:&nbsp;</label>
                        <label style="font-weight: 300">{{ serverName }}</label>
                    </div>

                    <v-btn class="mb-3" color="primary" width="100px" @click="logout">
                        {{ $t("res_MenuItems_Logout") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="otherSettingsDialog" content-class="profile-dialog m-0" width="380px">
            <v-card style="padding-bottom: 0px">
                <v-card-title class="p-0" style="margin-bottom: 1.75rem; line-height: 1.5rem">
                    {{ $t("res_MenuItems_OtherSettings") }}
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-row>
                            <v-col class="col-md-12">
                                <label>{{ $t("res_Label_SeeOldLetters") }}</label>
                                <v-checkbox v-model="userDefaultSettings.seeOldLettersDefaultValue"
                                            class="m-0"></v-checkbox>
                            </v-col>
                            <v-col class="col-md-12">
                                <label>{{ $t("res_Label_EnableAutoDelegationFromHRMS") }}</label>
                                <v-checkbox v-model="userDefaultSettings.enableAutoDelegationfromHRMS"
                                            class="m-0"></v-checkbox>
                            </v-col>
                            <v-col class="col-md-12">
                                <label>{{ $t("res_Label_EnableProfileUpdateFromHRMS") }}</label>
                                <v-checkbox v-model="userDefaultSettings.enableProfileUpdatefromHRMS"
                                            class="m-0"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="p-0">
                    <v-spacer></v-spacer>
                    <v-btn class="mb-3 line-height-20" color="primary" width="100px" @click="saveUserDefaultSettings()">
                        {{ $t("res_ButtonText_Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="changePinCodeDialog" content-class="small-dialog" width="350" height="750" persistent>
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_ChangePinCode") }}
                </v-card-title>
                <div class="card-body">
                    <div v-if="enableSignWithOutPinCodeFeature" class="d-flex align-items-end gap-2">
                        <label>{{ $t("res_Label_CanSignWithoutPin") }}</label>
                        <v-checkbox v-model="canSignWithoutPinCode" @change="updateCanSignWithoutPinCode"></v-checkbox>
                    </div>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label class="mb-2">{{ $t("res_Label_CurrentPinCode") }}<span style="color: red !important;"> *</span></label>
                            <v-text-field label="" :disabled="canSignWithoutPinCode" solo
                                          :type="pincode.showCurrent ? 'text' : 'password'" v-model="pincode.currentPinCode"
                                          :append-icon="pincode.showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="pincode.showCurrent = !pincode.showCurrent" autocomplete="current-password"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label class="mb-2">{{ $t("res_Label_SetNewPinCode") }}<span style="color: red !important;"> *</span></label>
                            <v-text-field label="" :disabled="canSignWithoutPinCode" solo
                                          :type="pincode.showNew ? 'text' : 'password'" v-model="pincode.setNewPin"
                                          :append-icon="pincode.showNew ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="pincode.showNew = !pincode.showNew" autocomplete="new-password"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label class="mb-2">{{ $t("res_Label_ConfirmNewPinCode") }}<span style="color: red !important;"> *</span></label>
                            <v-text-field label="" :disabled="canSignWithoutPinCode" solo
                                          :type="pincode.showConfirm ? 'text' : 'password'" v-model="pincode.confirmNewPin"
                                          :append-icon="pincode.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                                          @click:append="pincode.showConfirm = !pincode.showConfirm" autocomplete="new-password"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col class="col-md-12">
                            <label style="color: red !important;">{{ $t("res_Label_PincodeRefelctionAlert") }}</label>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click="closeChangePinCode"
                           :class="{ 'disabled': enableForceFullyChangeSignaturePin && isNeedResetSignaturePin }">
                        {{
                        $t("res_ButtonText_Cancel")
                        }}
                    </v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" :disabled="canSignWithoutPinCode"
                           @click="updatePinCode">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="setDefaultSignMethodDialog" content-class="small-dialog" width="350" height="300" persistent>
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_DefaultSignMethod") }}
                </v-card-title>
                <div class="card-body">
                    <v-row class="mt-2">
                        <v-col class="col-md-10">
                            <label class="pt-4">{{ $t("res_Lable_CanSignWithESign") }}</label>
                        </v-col>
                        <v-col class="col-md-2">
                            <v-checkbox v-model="allowESignature" @change="handleSignMethodChange('esign')"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-md-10">
                            <label class="pt-4">{{ $t("res_Lable_CanSignWithUAEPASS") }}</label>
                        </v-col>
                        <v-col class="col-md-2">
                            <v-checkbox v-model="allowUAEPASSSignature" @change="handleSignMethodChange('uaepass')"></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;" @click="setDefaultSignMethodDialog = false">
                        {{
                        $t("res_ButtonText_Cancel")
                        }}
                    </v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" :disabled="!allowESignature && !allowUAEPASSSignature"
                           @click="updateSignMethod">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="addTransferFavoriteDialog" width="40%">
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_AddTransferFavorite") }}
                </v-card-title>
                <div class="ml-15" style="height: 400px; overflow:scroll;">
                    <v-row class="my-3 ml-3">
                        <v-col class="col-md-8">
                            <span class="mx-3 my-3">
                                {{ $t("res_Label_TransferFavoriteStructure") }} <span style="color: red">*</span>
                            </span>
                            <v-divider></v-divider>
                            <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                                   :showInternalStructures="true" :showExternalStructures="false"
                                                   :excludeSelf="true" :isMultiple="true"
                                                   :selectedStructureUsersList="sampleFavList" :isSubscribedEntitiesEnable="constants.isFullAdmin"
                                                   @structureUserSelectChanged="setStructureUser($event)"
                                                   :addressBook_header="$t('res_Label_SelectStructure')">
                            </StructureUserSelector>
                        </v-col>
                        <!-- <v-divider></v-divider>-->
                        <draggable :list="this.transferFavoriteList" class="d-flex flex-row">
                            <v-card class="mx-5 my-5" elevation="5" style="padding: 10px;"
                                    v-for="(item, index) in this.transferFavoriteList" :key="index">
                                <v-row align="center" no-gutters>
                                    <v-col cols="auto" class="mr-2">
                                        <v-icon v-if="item.userId != 0" :style="{ color: (item.active == 'False') ? 'red' : 'green'}">mdi-account</v-icon>
                                        <v-icon v-else :style="{ color: (item.active == 'False') ? 'red' : 'green'}">mdi-folder-multiple-outline</v-icon>
                                    </v-col>
                                    <v-col cols="auto">
                                        <p :style="{color: item.active === 'False' ? 'red' : 'green', fontWeight: 300, fontSize: 'medium'}" class="mt-3">
                                            {{ item.name }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </draggable>
                    </v-row>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" style="min-width: 100px !important;"
                           @click="addTransferFavoriteDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn class="primary" style="min-width: 100px !important;" @click="addTransferFavorite">
                        {{ $t("res_ButtonText_Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="createIncomingDialog" content-class="dialog fullscreen-dialog bg-white" width="100%"
                  fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <div class="d-flex align-items-center">
                        <h1 class="mb-0">{{ this.createByFileTitle }}</h1>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="createIncomingDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <DWT :categoryId="dwtCategoryId" :dialogModelShow="createIncomingDialog"></DWT>
            </div>
        </v-dialog>

        <v-dialog persistent v-model="createOutgoingDialog"
                  content-class="dialog bg-white choose-template-dialog fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0 chose-template-header">{{ $t("res_MenuItems_ChooseTemplate") }}</h1>
                    <v-spacer></v-spacer>
                    <div id="treeview" class="mdi-icon-wrapper">
                        <v-icon @click="onTreeViewClick" v-tooltip.hover="$t('res_label_TreeView')">
                            mdi
                            mdi-family-tree
                        </v-icon>

                    </div>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="createOutgoingDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <ChooseTemplate @closeSelectTemplatePopup="closeSelectTemplatePopup" :isTreeView="isTreeView"
                                :categoryType="createOutgoingDialog_CategroyType" :dialogModelShow="createOutgoingDialog"
                                :refreshToken="refreshToken" :linkedDocumentId="linkedDocumentId"></ChooseTemplate>
            </div>
        </v-dialog>

        <v-dialog v-model="selectRecipientDialog" content-class="dialog2 h-90 with-fixed-actions" width="700">
            <div class="dialog-header">
                <h1>
                    {{ $t("res_MenuItems_Recipient") }}
                </h1>
            </div>
            <div class="dialog-body white-container">
                <address-book></address-book>
            </div>
        </v-dialog>

        <v-dialog v-model="newCorrespondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog"
                  fullscreen :persistent="true">
            <CreateDocumentView :documentId="draftDocumentId" :closeDialogEvent="closeNewCorrespondenceDialog"
                                :openedFromNodeId="1" :openerPage="createDocumentViewOpener" viewMode="edit"
                                :linkedFromDocumentId="linkedDocumentId"
                                :createReplyDocumentEvent="CreateReplyDocument" />
        </v-dialog>

        <v-alert v-if="snackbar_show" text :type="snackbar_type">
            {{ snackbar_text }}
        </v-alert>

        <v-dialog v-model="informationDialog" content-class="small-dialog" width="500" height="350"
                  style="z-index: 9999;">
            <v-card>
                <v-card-title>
                    <span>{{ information_heading }}</span>
                </v-card-title>
                <div class="card-body">
                    <label v-if="information_isHtml" v-html="information_text"></label>
                    <label v-else>{{ information_text }}</label>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" width="100" v-if="information_showCancelButton"
                           @click="informationDialogCancel">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" width="100" @click="informationDialogContinue">
                        {{
                        $t("res_ButtonText_Continue")
                        }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--System Notification Dialog-->
        <v-dialog v-model="SystemNotificationDialog" content-class="profile-dialog system-notifiction m-0"
                  width="430px">
            <v-card class="p-2 card-scroll">
                <div class="min-height-58px">
                    <div v-if="systemNotificationList.length == 0">
                        <p class="center-document mt-4"><strong>{{ $t("res_Notification_NoData") }}</strong></p>
                    </div>
                    <div v-if="systemNotificationList.length > 0" style="position: relative;"
                         v-for="(transferSystemNotification, index) in systemNotificationList" :key="index"
                         :class="{'border-bottom': index !== systemNotificationList.length - 1 , 'd-flex align-items-center' : 1==1}">
                        <div class="col-1">
                            <span v-if="!transferSystemNotification.isRead" class="blue-dot"></span>
                        </div>
                        <div class="col-11 pb-0" @click="openNotification(transferSystemNotification)"
                             style="font-size: 10px; cursor: pointer;">
                            <p class="mb-1">
                                <v-chip style="cursor: pointer" dark v-bind:color=getPurposeColor(transferSystemNotification)>{{ transferSystemNotification.purpose }}</v-chip>
                            </p>
                            -i
                            <p class="m-0 mb-2 size-14">

                                <!-- <span v-if="defaultApplicationId==1"> {{ $t("res_Notification_Correspondence")
                                    }}&nbsp;</span>
                                <span v-else> {{ $t("res_Notification_commonText") }}&nbsp;</span>-->
                                <strong>{{ transferSystemNotification.fullName }}</strong>
                            </p>
                            <p class="mb-1 text-truncate size-12">
                                {{ transferSystemNotification.referenceNumber }} - {{ transferSystemNotification.subject}}
                            </p>
                            <p class="m-0 mb-1 p-0 text-truncate text-start size-12" style="color: #c2c2c2; ">
                                {{ utils.formatDateTimeWithTime(transferSystemNotification.createdDate) }}
                            </p>
                        </div>
                        <div v-if="isLanguageEn"
                             style="position: absolute; right: 0; top: 0; padding: 0px; padding-top: 22px; cursor: pointer;"
                             @click="MakeSystemNotificationIsDismissed(transferSystemNotification)">
                            <v-icon>mdi-window-close</v-icon>
                        </div>
                        <div v-else
                             style="position: absolute; left: 0; top: 0; padding: 0px; padding-top: 22px; cursor: pointer;"
                             @click="MakeSystemNotificationIsDismissed(transferSystemNotification)">
                            <v-icon>mdi-window-close</v-icon>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <!--Public Announcements Dialog-->
        <v-dialog v-model="PublicAnnouncementsDialog" content-class="profile-dialog system-notifiction m-0"
                  width="500px">
            <v-card class="p-2 card-scroll">
                <div class="min-height-58px" style="padding: 15px;">
                    <!-- Dialog Header -->
                    <div class="announcements-header">
                        <h2 class="announcements-title">Announcements</h2>
                    </div>

                    <!-- Empty State -->
                    <div v-if="publicAnnouncementsList.length == 0" class="announcements-empty">
                        <p>{{ $t("res_Notification_NoData") }}</p>
                    </div>
                    <div v-if="publicAnnouncementsList.length > 0" class="announcements-list">
                        <div v-for="(announcement, index) in publicAnnouncementsList" :key="index" class="announcement-item"
                             style="cursor: pointer;" @click="openAnnouncementFromList(announcement)">

                            <!-- Content -->
                            <div class="announcement-content-box">

                                <div class="announcement-item-title">
                                    <v-icon style="color: #008a7a !important;">mdi-bullhorn</v-icon>
                                    <h3>{{ announcement.title }}</h3>
                                </div>

                                <p v-if="announcement.subtitle" class="announcement-item-subtitle">
                                    {{ announcement.subtitle }}
                                </p>

                                <!-- CTA Button -->
                                <div class="announcement-btn-wrapper" v-if="announcement.linkText && announcement.link">
                                    <v-btn class="announcement-btn" @click.stop="openAnnouncementLink(announcement)">
                                        <v-icon left small>mdi-check</v-icon>
                                        {{ announcement.linkText }}
                                    </v-btn>
                                </div>
                            </div>

                            <!-- Close Button -->
                            <v-icon class="announcement-item-close" @click.stop="MakePublicAnnouncementIsDismissed(announcement.id)">mdi-close</v-icon>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <!--Correspondence Dialog-->
        <v-dialog v-model="correspondenceDialogOpened"
                  content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen :persistent="true">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView :documentId="correspondenceDialogObject.documentId"
                                :transferId="correspondenceDialogObject.transferId" :viewMode="correspondenceDialogObject.viewMode"
                                :delegationId="correspondenceDialogObject.delegationId" :toEmail="correspondenceDialogObject.toEmail"
                                :emailCC="correspondenceDialogObject.emailCC" :closeDialogEvent="CloseCorrespondenceDialog"
                                :openedFromNodeId="correspondenceDialogObject.openedFromNodeId"
                                :createReplyDocumentEvent="CreateReplyDocument" />
        </v-dialog>

        <v-dialog v-model="manageUserSignaturesDialog" content-class="fullscreen-dialog" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0">
                        {{$t("res_Label_ManageSignatures")}}
                    </h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="manageUserSignaturesDialog=false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
                <UserSignatureManager :userid="userId" :dialogModelShow="manageUserSignaturesDialog"
                                      v-on:closeDialog="manageUserSignaturesDialog = false"></UserSignatureManager>
            </div>
        </v-dialog>

        <!--loader-->
        <div v-if="display_loader" class="cts_loader">
            <img width="148px" src="/assets/images/icons/loader.svg" />
            <p>{{ $t("res_Msgs_LoadingText") }}</p>
        </div>

        <!-- Announcement Modal -->
        <AnnouncementModal :announcement="this.currentAnnouncement"
                           :visible="showAnnouncementModal"
                           @update:visible="showAnnouncementModal = $event"
                           @close="closeAnnouncementModal" />
    </v-app>
</template>

<script>
    import DWT from './components/DWT'
    import axios from 'axios'
    import * as signalR from '@microsoft/signalr'
    import constants from './assets/js/constants'
    import MultiSelect from 'vue-multiselect'
    import CreateDocumentView from './views/CreateDocumentView'
    import AddressBook from '@/components/AddressBook.vue'
    import { mapGetters, mapActions } from 'vuex'
    import { getTransferPurposes } from '@/store/modules/lookups.js'
    import ChooseTemplate from './components/ChooseTemplate.vue'
    import router from './router/index.js'
    import AnnouncementModal from './components/AnnouncementModal.vue'
    import draggable from "vuedraggable"
    import * as utils from './assets/js/common.js'
    import MessagesUtil from '@/utils/messagesUtil'
    import UserSignatureManager from '@/components/UserSignatureManager.vue'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'App',
        components: {
            DWT, MultiSelect, CreateDocumentView, AddressBook, ChooseTemplate, draggable, StructureUserSelector, Multiselect, UserSignatureManager, AnnouncementModal
        },
        data: () => ({
            enablePublicAnnouncements: false,
            enableSignWithOutPinCodeFeature: false,
            canSignWithoutPinCode: false,
            showAnnouncementModal: false,
            isAnnouncementOpenedFromList: false,
            currentAnnouncement: {
                title: '',
                subtitle: '',
                description: '',
                imageUrl: null,
                link: '',
                linkText: '',
                id: 0,
                startDate: null,
                endDate: null,
            },
            isTreeView: constants.templateMode == 'card' ? false : true,
            loading: false,
            isAuthenticated: false,
            isLanguageEn: true,
            shown: false,
            user: null,
            profileDialog: false,
            otherSettingsDialog: false,
            userDisplayName: '',
            profession: '',
            userId: (JSON.parse(sessionStorage.getItem("user")) || { profile: {} }).profile.Id,
            focusField: 0,
            loginName: '',
            RoleName: '',
            userAbbreviation: '',
            userAbbreviationSrc: '',
            createByFileTitle: '',
            createIncomingDialog: false,
            manageUserSignaturesDialog: false,
            createOutgoingDialog: false,
            createOutgoingDialog_CategroyType: '',
            refreshToken: '',
            fileUploaded: null,
            expandSearch: false,
            defaultSender: {},
            inboxCount: 0,
            draftCount: 0,
            sentCount: 0,
            ccedCount: 0,
            followUpCount: 0,
            archiveCount: 0,
            userInboxCount: 0,
            structureInboxCount: 0,
            linkedDocumentId: 0,

            newCorrespondenceDialog: false,
            selectRecipientDialog: false,
            search_mode: 'All',
            search_modes: ['All', 'Correspondences', 'Notes', 'Attachments', 'Users', 'Templates', 'Reports'],
            draftDocumentId: 0,
            user_structure: {},

            searchQuery: '',
            display_loader: false,
            snackbar_show: false,
            snackbar_text: '',
            snackbar_type: '',

            informationDialog: false,
            information_heading: '',
            information_text: '',
            information_isHtml: false,
            information_continueHandler: null,
            information_cancelHandler: null,
            information_showCancelButton: true,

            changePinCodeDialog: false,
            setDefaultSignMethodDialog: false,
            allowESignature: false,
            allowUAEPASSSignature: false,

            pincode: {
                setNewPin: "",
                currentPinCode: "",
                confirmNewPin: "",
                showCurrent: false,
                showNew: false,
                showCurrent: false,
                showConfirm: false
            },
            dateTimeOptions: {
                year: "numeric",
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            dateOptions: {
                year: "numeric",
                month: '2-digit',
                day: '2-digit'
            },
            addTransferFavoriteDialog: false,
            transferFavoriteList: [],
            sampleFavList: [],
            allStructures: [],
            all_user_structures: [],

            isDecreeEnabled: false,
            isContarctEnabled: false,
            isCircularEnabled: false,
            createDocumentViewOpener: "",
            constants: constants,
            hasUnOpenedDocuments: false,
            router: router,
            messagesUtil: MessagesUtil,
            showLoadingCount: 0,
            client_logo_name: client_logo_name,
            dwtCategoryId: 1,
            systemNotificationList: [],
            SystemNotificationDialog: false,
            publicAnnouncementsList: [],
            PublicAnnouncementsDialog: false,
            correspondenceDialogOpened: false,
            correspondenceDialogObject: {
                documentId: 0,
                transferId: 0,
                viewMode: 'edit',
                delegationId: 0,
                toEmail: "",
                emailCC: "",
                closeDialogEvent: 0,
                openedFromNodeId: 2,
            },
            utils: utils,
            menuItems: [],
            defaultApplicationId: window.defaultApplicationId,
            showCreateOutgoingByFile: true,
            showAppSwitchButton: window.showAppSwitchButton,
            availableApplications: window.availableApplications,
            showInProfileMenus: window.showInProfileMenus,
            CreateOutgoingByTemplateDefault: window.CreateOutgoingByTemplateDefault,
            enableMOFALabels: window.enableMOFALabels,
            selectedItem: null,
            selected: [],
            privacies: [],
            priorities: [],
            from_date_datePicker: false,
            to_date_datePicker: false,
            hideElasticSearch: window.hideElasticSearch,
            TaskDetailsDialogOpened: false,
            TaskProjecDialogOpened: false,
            taskDialogObject: {
                linkedWithProject: true,
                selectedTaskId: 0,
                projectId: 0,
                isProjectCreator: false,
                isPublic: false
            },
            enableForceFullyChangeSignaturePin: window.enableForceFullyChangeSignaturePin,
            isNeedResetSignaturePin: false,
            userProfileImage: {
                contentType: '',
                data: ''
            },
            profileImage: '',
            userDefaultSettings: {
                seeOldLettersDefaultValue: false,
                enableAutoDelegationfromHRMS: false,
                enableProfileUpdatefromHRMS: false
            },
            serverName: '',
            isMenuShow: false,
            applicationRoles: [],
            purposes: getTransferPurposes(),
            systemNotificationsConnection: null,
        }),
        async created() {
            this.setRtl();
            this.isDecreeEnabled = constants.isDecreeEnabled
            this.isContarctEnabled = constants.isContarctEnabled
            this.isCircularEnabled = constants.isCircularEnabled
            this.showCreateOutgoingByFile = window.showCreateOutgoingByFile

            window.openNewCreateDocumentView = this.openNewCreateDocumentView;
            window.addEventListener('message', function (event) {
                try {
                    // console.log(event.data);
                    // the below handles coming from ther scanning module
                    if (event.data != undefined && event.data != '' && event.data.lastIndexOf('documentId:') > -1) {
                        var documentId = event.data.replace("documentId:", "");
                        if (isNaN(documentId) == false) {
                            window.openNewCreateDocumentView(parseInt(documentId));
                        }
                    }
                }
                catch (e) { }
            });

            if (sessionStorage.getItem("user") != null) {
                var user = JSON.parse(sessionStorage.getItem("user"))
                this.isAuthenticated = true
                this.user = user.profile
                this.userAbbreviation = this.CapitalizeFirstLetter(this.user.DisplayName)

                axios.get(constants.baseApiUrl + 'User/GetUserPhotoAttachment?userId=' + this.user.Id)
                    .then(response => {
                        if (response.data != null && response.data != undefined) {
                            this.userProfileImage = {
                                contentType: response.data.item1,
                                data: response.data.item2
                            }
                            const dataURL = `data:${this.userProfileImage.contentType};base64,${this.userProfileImage.data}`;
                            this.profileImage = dataURL
                        }
                    })
                    .catch(error => console.log(error))

                this.fetchUserStructures(() => {
                    var user = JSON.parse(sessionStorage.getItem("user"))

                    this.all_user_structures = [...this.allUserStructures]
                    this.all_user_structures.forEach(element => {
                        if (element.structureId == user.profile.StructureId) {
                            this.user_structure = element
                            sessionStorage.setItem('user_structure', JSON.stringify(element))
                        }
                    });
                })
                this.getRoles()

                // this.messagesUtil.dispatchEvent('userLoaded');

                if (window.defaultApplicationId == 1) {
                    await this.fetchDocumentCategories()
                }
            }
        },
        beforeMount() {
            window.documentView = {}
            window.showAlert = this.showAlert
            window.showLoading = this.showLoading
            window.hideLoading = this.hideLoading
            window.newDate = this.newDate
            window.dateFormatForExternlUse = utils.dateFormat;
            window.showInformation = this.showInformation
            window.openNewCorrespondenceDialog = this.openNewCorrespondenceDialog
            window.translate = this.translate
            window.dateTimeOptions = this.dateTimeOptions
            window.dateOptions = this.dateOptions
            window.clearViewerData = this.clearViewerData;
            window.setViewerData = this.setViewerData;
            window.getViewerData = this.getViewerData;
            window.setVisualTrackingData = this.setVisualTrackingData;
            window.setConfigureSignatureData = this.setConfigureSignatureData;
            window.getLocalizedVal = this.getLocalizedVal;

            window.refreshUnOpenedDocument = this.checkForUnOpenedDocuments;
            window.refreshBoxCounters = this.loadUnreadCounters;
            window.decrementBoxCount = this.decrementBoxCount;
        },
        async mounted() {
            const lang = localStorage.getItem('lang');
            if (lang == "undefined")
                localStorage.setItem('lang', defaultApplicationLanguage);
            this.enablePublicAnnouncements = window.enablePublicAnnouncements
            this.enableSignWithOutPinCodeFeature = window.enableSignWithOutPinCodeFeature
            this.canSignWithoutPinCode = await this.fetchCanSignWithoutPin();
            var appContext = this
            this.isTreeView = constants.templateMode == 'card' ? false : true
            this.privacies = constants.privacies;
            this.priorities = constants.priorities;
            var treeviewicon = document.getElementById('treeview');
            if (treeviewicon)
                treeviewicon.style.border = this.isTreeView ? "2px solid lightgrey" : "none"

            this.messagesUtil.listenToEvents(function (eventDetail) {
                if (eventDetail.key == 'createOutgoingOnIncoming') {
                    appContext.refreshToken = new Date().getTime().toString();
                    appContext.createOutgoingDialog_CategroyType = '';
                    appContext.createOutgoingDialog = true
                    appContext.linkedDocumentId = eventDetail.documentId ? Number(eventDetail.documentId) : 0
                }
            });

            setInterval(function () {
                if (document.getElementsByClassName('bottom-action-bar').length > 0)
                    document.body.classList.add('alert-top')
                else
                    document.body.classList.remove('alert-top')
            }, 1000)

            var user = JSON.parse(sessionStorage.getItem("user"));
            if (user == null)
                document.getElementById("login").click();

            // Load announcements on app initialization
            if (this.enablePublicAnnouncements && user != null)
                this.loadAnnouncements();

            this.search_mode = this.translate('res_CardHeaders_All'),
                this.search_modes = [this.translate('res_CardHeaders_All'), this.translate("res_MenuItems_Correspondences"),
                this.translate("res_MenuItems_Notes"), this.translate("res_Label_Attachments"), this.translate("res_MenuItems_Users"),
                this.translate("res_MenuItems_Templates"), this.translate("res_TabsName_Reports")]

            if (constants.isDelegationsLoaded == false) {
                axios.get(constants.baseApiUrl + 'Delegation/GetAllActiveDelegationsForUser')
                    .then(res => {
                        constants.delegations = res.data
                        constants.isDelegationsLoaded = true
                    })
                    .catch(err => console.log(err));
            }

            if (window.defaultApplicationId == 1 || window.defaultApplicationId == 2) {
                this.setCounters()
                // The badges are driven by SignalR; this slow refresh is only a safety net for
                // events missed while the connection was down.
                setInterval(() => { this.setCounters() }, 60000)
                this.startNotificationsTimer();
                if (this.enablePublicAnnouncements)
                    this.startPublicAnnouncementsTimer();
            }

            axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=Countries')
                .then(response => constants.countriesList = response.data)
                .catch(error => console.log(error))

            if (constants.client_version_Id != "") {
                axios.get(constants.baseApiUrl + 'Lookups/GetCustomLookupValues?name=MessageTypes')
                    .then(response => constants.messageTypes = response.data)
                    .catch(error => console.log(error))
            }

            if (constants.disclaimerMessage != null && constants.disclaimerMessage != undefined && constants.disclaimerMessage != '') {
                this.addFloatingDisclaimer(constants.disclaimerMessage)
            }
            var user = JSON.parse(sessionStorage.getItem("user"))
            this.userId = user.profile.Id
            this.isNeedResetSignaturePin = user.profile.IsNeedResetSignaturePin

            if (this.isNeedResetSignaturePin && this.enableForceFullyChangeSignaturePin)
                this.changeSignaturePin();
            sessionStorage.setItem('viewer_mode', 'web')
        },
        computed: {
            ...mapGetters(['allUserStructures']),
        },
        beforeDestroy() {
            // also stops the announcements updates, they share the same SignalR connection
            this.clearNotificationsTimer();
        },
        methods: {
            getServerName() {
                axios.get(constants.baseApiUrl + 'StructureUser/GetServerName')
                    .then((res) => {
                        this.serverName = res.data
                    })
                    .catch((err) => console.log(err))
            },
            getUserProfession(structureId) {
                var currentStructureId = this.user_structure.structureId == null ? structureId : this.user_structure.structureId
                axios.get(constants.baseApiUrl + 'User/GetUserInfo?userId=' + this.userId + '&structureId=' + currentStructureId)
                    .then((res) => {
                        this.profession = this.isLanguageEn == true ? res.data.profession : res.data.professionAr
                    })
                    .catch((err) => console.log(err))
            },
            getPurposeColor(item) {
                var purposeItem = this.purposes.find(x => x.id == item.purposeId)
                if (purposeItem != null)
                    return purposeItem.color
                return ''
            },
            getCount(path) {
                switch (path) {
                    case '/inbox':
                        return this.inboxCount;
                    case '/cced':
                        return this.ccedCount;
                    case '/draft':
                        return this.draftCount;
                    case '/sent':
                        return this.sentCount;
                    case '/followup':
                        return this.followUpCount;
                    case '/archive':
                        return this.archiveCount;
                    case '/inbox-user':
                        return this.userInboxCount;
                    case '/inbox-structure':
                        return this.structureInboxCount;
                    default:
                        return 0;
                }
            },
            async fetchCanSignWithoutPin() {
                try {
                    const response = await axios.get(constants.baseApiUrl + 'User/GetCanSignWithoutPinCode');
                    const responseData = response.data;
                    const canSignWithoutPinCode = responseData && this.enableSignWithOutPinCodeFeature;
                    return canSignWithoutPinCode;
                }
                catch (error) {
                    console.log(error);
                    return false;
                }
            },
            async updateCanSignWithoutPinCode() {
                try {
                    window.showLoading()
                    var response = await axios.post(constants.baseApiUrl + 'User/UpdateCanSignWithoutPinCode?canSignWithoutPinCode=' + this.canSignWithoutPinCode);
                    this.canSignWithoutPinCode = response.data ? true : false
                    if (this.canSignWithoutPinCode)
                        window.showAlert(this.translate('res_Msgs_SignWithoutPinCodeEnabled'), 'success')
                    else
                        window.showAlert(this.translate('res_Msgs_SignWithoutPinCodeDisabled'), 'success')
                }
                catch (error) {
                    console.log(error);
                }
                finally {
                    window.hideLoading()
                }
            },
            handleSignMethodChange(type) {
                if (type === 'esign') {
                    if (!this.allowESignature && !this.allowUAEPASSSignature) {
                        this.allowUAEPASSSignature = true
                    }
                }

                if (type === 'uaepass') {
                    // If user unchecked UAEPASS and eSign is also unchecked → force eSign
                    if (!this.allowUAEPASSSignature && !this.allowESignature) {
                        this.allowESignature = true
                    }
                }
            },
            displayUserImage() {
                let byteArray = this.userProfileImage.data
                const base64String = btoa(String.fromCharCode.apply(null, byteArray));
                const dataURL = `data:${contentType};base64,${base64String}`;
                return dataURL;
            },
            onTreeViewClick() {
                this.isTreeView = !this.isTreeView;
                var treeviewicon = document.getElementById('treeview');
                treeviewicon.style.border = this.isTreeView ? "2px solid lightgrey" : "none"
            },
            CreateReplyDocument(documentId) {
                this.refreshToken = new Date().getTime().toString()
                this.createOutgoingDialog_CategroyType = ''
                this.linkedDocumentId = documentId ? Number(documentId) : 0
                this.createOutgoingDialog = true
            },
            closeTaskDetailsDialog() {
                this.taskDialogObject = {};
                this.TaskDetailsDialogOpened = false;
                this.TaskProjecDialogOpened = false;
            },
            closeTaskProjectDialog() {
                this.taskDialogObject = {};
                this.TaskDetailsDialogOpened = false;
                this.TaskProjecDialogOpened = false;
            },
            setStructureUser(items) {
                this.sampleFavList = items

                const validItems = items.filter(i => i && i.id && i.id !== "0")
                const unique = [...new Map(validItems.map(i => [i.id, i])).values()]

                this.transferFavoriteList = unique.map(y => ({
                    userId: y.isUser ? y.id.split('-')[0] : 0,
                    structureId: y.isUser ? y.id.split('-')[1] : y.id,
                    name: y.name,
                    isUser: y.isUser
                }))

            },
            ...mapActions(['fetchUserStructures', 'fetchDocumentCategories']),
            openAddSignatureDialog() {
                console.log('true');
                this.isSignatureModelShow = true;
            },
            openProfileBox() {
                var user = JSON.parse(sessionStorage.getItem("user"))
                this.getServerName();
                this.userDisplayName = user.profile.DisplayName
                this.userId = user.profile.Id
                this.profession = this.getUserProfession(user.profile.StructureId);
                this.loginName = user.profile.Username
                this.profileDialog = !this.profileDialog
                this.RoleName = this.applicationRoles.find(x => x.id == user.profile.ApplicationRoleId).name
            },
            // Announcement Methods
            closeAnnouncementModal() {
                this.showAnnouncementModal = false;
                if (!this.isAnnouncementOpenedFromList && this.currentAnnouncement && this.currentAnnouncement.id) {
                    this.MakeLatestPublicAnnouncementIsDismissed(this.currentAnnouncement.id);
                }
                this.isAnnouncementOpenedFromList = false;
            },
            openAnnouncementFromList(announcement) {
                this.currentAnnouncement = {
                    id: announcement.id,
                    title: announcement.title,
                    subtitle: announcement.subtitle,
                    description: announcement.description,
                    imageUrl: announcement.imageUrl,
                    link: announcement.link,
                    linkText: announcement.linkText,
                    startDate: announcement.startDate,
                    endDate: announcement.endDate,
                };
                this.isAnnouncementOpenedFromList = true;
                this.PublicAnnouncementsDialog = false;
                this.showAnnouncementModal = true;
            },
            openOtherSettings() {
                window.showLoading()
                this.profileDialog = false
                this.getUserDefaultSettings()
            },
            hasPermission(name) {
                if (constants.userActions && constants.userActions.features) {
                    return constants.userActions.features.some(f => f.name.toLowerCase() == name.toLowerCase());
                }

                return false;
            },
            userStructureChanged() {
                axios.post(constants.baseApiUrl + 'StructureUser/ChangeUserDefaultStructure?structureId=' + this.user_structure.structureId, null)
                    .then(response => {
                        sessionStorage.setItem('user', null)
                        sessionStorage.setItem('userPinCode', null)
                        sessionStorage.setItem('jwt_token', null)
                        window.location.href = window.location.origin + '/login2.html'
                    })
                    .catch(error => console.log(error));
            },
            changeRTL(direction) {
                this.showLoading();
                this.isLanguageEn = direction ? false : true;
                this.$vuetify.rtl = direction
                const lang = direction ? 'ar' : 'en'
                localStorage.setItem('lang', lang)

                axios.post(constants.baseApiUrl + 'User/ChangePreferredLanguage?language=' + lang, null)
                    .then(response => {
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.location.reload());
            },
            setRtl() {
                var stored = localStorage.getItem('lang');
                var lang = (stored == 'en' || stored == 'ar') ? stored : defaultApplicationLanguage;
                var isDirectionRtl = lang == 'ar';
                this.isLanguageEn = isDirectionRtl ? false : true;
                this.$i18n.locale = lang
                this.$vuetify.rtl = isDirectionRtl
                document.documentElement.lang = lang
            },
            logout() {
                document.getElementById("logout").click();
            },
            openCreateIncomingPopup() {
                this.dwtCategoryId = 1
                this.createByFileTitle = this.translate("res_MenuItems_CreateIncoming")
                this.createIncomingDialog = true
            },
            openCreateOutgoingAttachPopup() {
                this.dwtCategoryId = 2
                this.createByFileTitle = this.translate("res_MenuItems_CreateOutgoing")
                this.createIncomingDialog = true
            },
            DownloadFile(url) {
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });

                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, "PrintedFile.pdf");
                    }
                    else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "PrintedFile.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
            },
            openCreateOutgoingPopup(categoryType) {
                this.refreshToken = new Date().getTime().toString()
                this.createOutgoingDialog_CategroyType = categoryType
                this.linkedDocumentId = 0
                this.createOutgoingDialog = true
            },
            uploadFile() {
                this.fileUploaded = this.$refs.file.files[0];
            },
            closeNewCorrespondenceDialog(context) {
                this.draftDocumentId = 0
                this.linkedDocumentId = 0
                this.newCorrespondenceDialog = false
                if (window.refreshInbxGrid != undefined && window.refreshInbxGrid != null)
                    window.refreshInbxGrid()
                switch (context.openerPage) {
                    case "chooseTemplate":
                        this.createOutgoingDialog = true
                        this.createOutgoingDialog_CategroyType = context.document.categoryId
                        break;
                    case "createIncomingDialog":
                        this.createIncomingDialog = true
                        break;
                    default:
                        console.log(context.openerPage);
                }
            },
            closeSelectTemplatePopup(documentId) {
                this.createOutgoingDialog_CategroyType = ''
                this.createOutgoingDialog = false
                if (documentId != 0) {
                    this.openNewCorrespondenceDialog(documentId)
                }
                else {
                    this.draftDocumentId = 0
                    this.linkedDocumentId = 0
                }
            },
            openNewCorrespondenceDialog(documentId) {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'User/GetCurrentUser')
                    .then(res => {
                        if (res.data != null && res.data != undefined) {
                            this.defaultSender = {}
                            this.defaultSender.id = res.data[0].structureId;
                            this.defaultSender.name = res.data[0].structureName;
                            this.defaultSender.isUser = false;
                        }
                        this.draftDocumentId = documentId != null ? String(documentId) : '0'
                        if (this.linkedDocumentId > 0 && documentId)
                            sessionStorage.setItem('pendingLinkedDocument_' + documentId, this.linkedDocumentId)
                        this.createDocumentViewOpener = "chooseTemplate";
                        this.newCorrespondenceDialog = true;
                    }
                    ).catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            openNewCreateDocumentView(documentId) {
                this.defaultSender = {}
                this.draftDocumentId = documentId
                this.createDocumentViewOpener = "createIncomingDialog";
                this.newCorrespondenceDialog = true
                this.createIncomingDialog = false
            },
            showAlert(text, type) {
                var textValue = this.translate(text)
                this.snackbar_text = this.translate(textValue);
                this.snackbar_type = type;
                this.snackbar_show = true;
                setTimeout(() => {
                    this.snackbar_show = false;
                }, 3000);
            },
            showInformation(heading, text, continueHandler, cancelHandler, isHtml) {
                this.information_heading = this.translate(heading)
                this.information_text = this.translate(text)
                this.information_isHtml = isHtml === true
                this.information_continueHandler = continueHandler
                if (cancelHandler != null && cancelHandler != undefined)
                    this.information_cancelHandler = cancelHandler
                else
                    this.information_showCancelButton = false
                this.informationDialog = true
            },
            informationDialogCancel() {
                this.informationDialog = false
                if (this.information_cancelHandler != null)
                    this.information_cancelHandler()
            },
            informationDialogContinue() {
                this.informationDialog = false
                if (this.information_continueHandler != null)
                    this.information_continueHandler()
            },
            showLoading() {
                this.display_loader = true
                this.showLoadingCount++;
            },
            hideLoading() {
                this.showLoadingCount--;
                if (this.showLoadingCount < 1) {
                    this.showLoadingCount = 0;
                    this.display_loader = false
                }
            },
            newDate() {
                return new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000);
            },
            clearSearchResult() {
                this.expandSearch = false;
                this.searchQuery = '';
            },
            searchButtonClicked() {
                var r = new Date().getTime().toString()
                if (this.searchQuery.trim().length < 3) {
                    window.showAlert(this.translate("res_Msg_MinThreeCharsToSearch"), 'error');
                    return false;
                }
                if (this.searchQuery != null && this.searchQuery != undefined && this.searchQuery != '') {
                    if (this.search_mode == this.translate('res_CardHeaders_All'))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '1', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Correspondences"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '2', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Notes"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '3', r: r } })

                    else if (this.search_mode == this.translate("res_Label_Attachments"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '4', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Users"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '5', r: r } })

                    else if (this.search_mode == this.translate("res_MenuItems_Templates"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '6', r: r } })

                    else if (this.search_mode == this.translate("res_TabsName_Reports"))
                        router.push({ path: 'search', query: { q: this.searchQuery, t: '7', r: r } })
                }
                else {
                    window.showAlert("res_Msgs_ProvideQuery", 'warning');
                }
            },
            getRoles() {
                axios.get(constants.baseApiUrl + 'Document/get-all-roles')
                    .then(res => {
                        constants.isApplicaitonRolesLoaded = true
                        if (res.data != null && res.data != undefined)
                            this.applicationRoles = res.data
                    })
            },
            clearPinCodeFileds() {
                this.pincode.currentPinCode = "";
                this.pincode.setNewPin = "";
                this.pincode.confirmNewPin = "";
            },
            async verifyCurrentPinCode() {
                try {
                    const response = await axios.get(constants.baseApiUrl + 'Document/CheckHasValidPin?pinValue=' + this.pincode.currentPinCode + '&canSignWithoutPinCode=false');
                    if (response?.data?.item1 === true)
                        return true;

                    if (response?.data?.item2 == 'SignaturePinNotSet')
                        throw new Error(this.translate('res_Msgs_PinNotSet'));

                    if (response?.data?.item2 == 'NoDefaultSignatureFound')
                        throw new Error(this.translate('res_Msgs_NoDefaultSignature'));

                    throw new Error(this.translate('res_Msgs_InvalidCurrentPin'));
                }
                catch (error) {
                    if (error instanceof Error)
                        throw error;

                    throw new Error(this.translate('res_Msgs_InvalidCurrentPin'));
                }
            },
            openAddTransferFavorite() {
                this.profileDialog = false
                this.transferFavoriteList = [];
                this.sampleFavList = []

                axios.get(constants.baseApiUrl + 'Transfer/GetTransferFavorite?UserId=' + this.userId
                    + '&StructureId=' + this.user_structure.structureId, { headers: constants.headers })
                    .then(response => {
                        if (response.data != null && response.data) {
                            response.data.forEach(fav => {
                                var favLstBody = {
                                    userId: fav.favUserId,
                                    structureId: fav.favStructureId,
                                    name: fav.name,
                                    active: fav.active
                                }

                                this.transferFavoriteList.push(favLstBody)

                                this.sampleFavList.push({
                                    id: fav.favUserId ? fav.favUserId + "-" + fav.favStructureId : fav.favStructureId,
                                    name: fav.name,
                                    isUser: fav.favUserId ? true : false
                                })
                            })
                        }
                    })
                    .catch(err => console.warn(err))

                this.addTransferFavoriteDialog = true;
            },
            openChangePinCode() {
                this.changePinCodeDialog = true
            },
            closeChangePinCode() {
                this.changePinCodeDialog = false;
                this.clearPinCodeFileds();
            },
            openDefaultSignerMethod() {
                axios.post(constants.baseApiUrl + 'StructureUser/GetDefaultSignerMethod', null)
                    .then(response => {
                        if (response.data != null) {
                            this.allowESignature = response.data.allowESignature,
                                this.allowUAEPASSSignature = response.data.allowUAEPASSSignature
                            this.setDefaultSignMethodDialog = true
                        }
                    }).catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            openManageExternalEntities() {
                this.profileDialog = false
                router.push({ path: 'admin/manage-external-entities' })
            },
            addTransferFavorite() {
                if (this.transferFavoriteList.length > 0) {
                    var body = {
                        userId: this.userId,
                        structureId: this.user_structure.structureId,
                        FavUserIds: this.transferFavoriteList
                            .map(a => a.userId),
                        FavStructureIds: this.transferFavoriteList
                            .map(a => a.structureId)
                    };

                    axios.post(constants.baseApiUrl + 'Transfer/UpdateTransferFavorite', body, { headers: constants.headers })
                        .then(response => {
                            if (response.data != null && response.data) {
                                window.showAlert(this.translate("res_Msgs_NewTransferFavoriteStructureAddition"), 'success');
                                this.addTransferFavoriteDialog = false;
                            }
                        })
                        .catch(err => console.warn(err))
                }
            },
            async updatePinCode() {
                if (this.pincode.currentPinCode != "" && this.pincode.setNewPin != "" && this.pincode.confirmNewPin != "") {
                    if (this.pincode.setNewPin == this.pincode.confirmNewPin) {
                        window.showLoading()
                        try {
                            await this.verifyCurrentPinCode();

                            var body = { NewSignaturePin: this.pincode.confirmNewPin }
                            const response = await axios.post(constants.baseApiUrl + 'User/UpdateUserSignaturePin', body, { headers: constants.headers })

                            if (response.data != null && response.data > 0) {
                                window.showAlert(this.translate("res_Msgs_SignaturePinCodeUpdation"), 'success');
                                this.clearPinCodeFileds();
                                this.changePinCodeDialog = false;
                                this.isNeedResetSignaturePin = false;
                            }
                            else if (response.data != null && response.data == -1) {
                                window.showAlert(this.translate("res_Msgs_AddPinCodeFirst"), 'warning');
                                this.clearPinCodeFileds();
                                this.changePinCodeDialog = false;
                            }
                            else {
                                throw new Error(this.translate("res_Msgs_WrongPinCode"));
                            }
                        }
                        catch (err) {
                            window.showAlert(err?.message || this.translate("res_Msgs_WrongPinCode"), 'error');
                            console.warn(err)
                        }
                        finally {
                            window.hideLoading()
                        }
                    }
                    else
                        window.showAlert(this.translate("res_Msgs_PinCodeNotMatching"), 'warning')
                }
                else
                    window.showAlert(this.translate("res_Msgs_FillRequired"), 'warning')
            },
            updateSignMethod() {
                var body = {
                    UserId: this.userId,
                    StructureId: this.user_structure.structureId,
                    AllowESignature: this.allowESignature,
                    AllowUAEPASSSignature: this.allowUAEPASSSignature
                }

                axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureUserSignPrivilege', body, { headers: constants.headers })
                    .then(response => {
                        if (response.data != null && response.data == "success") {
                            window.showAlert(this.translate("res_Msgs_SignatureMethodsAlert"), 'success');
                            this.setDefaultSignMethodDialog = false;
                        }
                    })
                    .catch(err => console.warn(err))
            },
            asyncFindStructure(query) {
                if (query == '') return;

                this.allStructures = [];
                var methodUrl = 'StructureUser/SearchWithAddressbook?showInternalUsers=true&showInternalStructures=true&'
                    + 'hideStructureWithDisableTransfer=true&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => {
                        this.allStructures = res.data;
                    })
                    .catch(err => console.warn(err))
            },
            translate(text) {
                if (this.$i18n.locale == 'en')
                    return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
                else
                    return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
            },
            CapitalizeFirstLetter(str) {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options) {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            checkForUnOpenedDocuments() {
                this.loadUnreadCounters();
            },
            getBoxCount(nodeId) {
                /*
                if (nodeId == 2) {
                    axios.get(constants.baseApiUrl + 'Document/CheckUserHasUnOpenedDocument')
                        .then(res => {
                            this.inboxCount = res.data;console.log('inbox 2  = ',res.data)
                            this.hasUnOpenedDocuments = (res.data > 0 ? true : false)
                        })
                        .catch(err => console.log(err));
                }
                else {

                    var request = {
                        NodeId: nodeId,
                        DelegationId: 0,
                        PageIndex: 0,
                        PageSize: 20,
                        GetCountOnly: true,
                    }

                    axios.post(constants.baseApiUrl + 'Transfer/List', request)
                        .then((res) => {
                            if (nodeId == 1)
                                this.draftCount = res.data
                            else if (nodeId == 6)
                                this.sentCount = res.data
                            else if (nodeId == 8)
                                this.archiveCount = res.data
                            else if (nodeId == 9)
                                this.followUpCount = res.data
                            else if (nodeId == 10)
                                this.ccedCount = res.data
                        })
                        .catch(err => console.log(err));
                }
                */
            },
            clearViewerData() {
                this.viewerData = null
                this.viewerStatusId = null
                this.viewerCategoryId = null
                this.viewerFlagsDocumentId = null
            },
            setViewerData(id, documentId, versionId, fileName, openedByCreator, statusId, categoryId) {
                if (statusId != null || categoryId != null || this.viewerFlagsDocumentId != documentId) {
                    this.viewerStatusId = statusId
                    this.viewerCategoryId = categoryId
                    this.viewerFlagsDocumentId = documentId
                }

                this.viewerData = [{ key: 'id', value: id }, { key: 'documentid', value: documentId }];
                if (versionId) {
                    this.viewerData.push({ key: 'versionid', value: versionId });
                }
                if (fileName) {
                    this.viewerData.push({ key: 'filename', value: fileName });
                }
                if (openedByCreator) {
                    this.viewerData.push({ key: 'openedbycreator', value: openedByCreator });
                }
                if (this.viewerStatusId != null) {
                    this.viewerData.push({ key: 'statusid', value: this.viewerStatusId });
                }
                if (this.viewerCategoryId != null) {
                    this.viewerData.push({ key: 'categoryid', value: this.viewerCategoryId });
                }
            },
            getViewerData(key) {
                if (this.viewerData) {
                    if (key)
                        key = key.toLowerCase()

                    let item = this.viewerData.filter(x => x.key == key)[0];
                    if (item)
                        return item.value
                }
                return null
            },
            setVisualTrackingData(documentId) {
                sessionStorage.setItem("s_swq", documentId);
            },
            setConfigureSignatureData(documentId, attachmentId) {
                sessionStorage.setItem("config_swq_id1", documentId);
                sessionStorage.setItem("config_swq_id2", attachmentId);
            },
            getLocalizedVal(enVal, arVal) {
                if (this.$i18n.locale == 'ar' && arVal) {
                    return arVal;
                }

                return enVal;
            },
            setCounters() {
                this.loadUnreadCounters();
            },
            // All sidebar badges come back in a single call (usp_GetDocumentsStatistic).
            // It runs on startup, on the SignalR 'TransferCountsChanged' event and after a
            // correspondence is opened, so no polling loop is needed.
            loadUnreadCounters() {
                if (!enableCountOnInbox && !enableCountOnCced &&
                    !enableCountOnFollowUp)
                    return

                axios.get(constants.baseApiUrl + 'Document/GetInboxNotOpenedDocumentsCounts')
                    .then(res => {
                        if (res == null || res.data == null)
                            return

                        if (enableCountOnInbox) {
                            this.inboxCount = res.data.inboxUnreadCount
                            this.userInboxCount = res.data.userInboxUnreadCount
                            this.structureInboxCount = res.data.structureInboxUnreadCount
                            this.hasUnOpenedDocuments = res.data.inboxUnreadCount > 0
                        }
                        if (enableCountOnCced) this.ccedCount = res.data.cCedInboxUnreadCount
                        if (enableCountOnFollowUp) this.followUpCount = res.data.followupUnreadCount
                    })
                    .catch(err => console.log(err));
            },
            // Called when a correspondence is opened: the badge drops right away so the user
            // sees the effect, then the server value is reloaded to keep the two in sync.
            decrementBoxCount(nodeId) {
                if (nodeId == 2 && this.inboxCount > 0) {
                    this.inboxCount--
                    this.hasUnOpenedDocuments = this.inboxCount > 0
                }
                else if (nodeId == 10 && this.ccedCount > 0)
                    this.ccedCount--
                else if (nodeId == 9 && this.followUpCount > 0)
                    this.followUpCount--
                // Sent (6) is not decremented here: that badge counts what the recipient has
                // not opened yet, so the sender opening it changes nothing.

                setTimeout(() => { this.loadUnreadCounters() }, 1500)
            },
            GetAllSystemNotifications() {
                axios.get(constants.baseApiUrl + 'SystemNotification/GetAllSystemNotifications')
                    .then(response => {
                        if (response.data != null && response.data != undefined)
                            this.systemNotificationList = response.data
                    })
                    .catch(error => console.log(error));
            },
            GetAllPublicAnnouncements() {
                axios.get(constants.baseApiUrl + 'SystemNotification/GetAllPublicAnnouncements')
                    .then(response => {
                        if (response.data != null && response.data != undefined)
                            this.publicAnnouncementsList = response.data
                    })
                    .catch(error => console.log(error));
            },
            async loadAnnouncements() {
                try {
                    const response = await axios.get(
                        constants.baseApiUrl + "SystemNotification/GetLatestPublicAnnouncement"
                    );

                    if (response.data) {
                        const announcement = Array.isArray(response.data)
                            ? response.data[0]
                            : response.data;

                        if (announcement && typeof announcement === "object") {
                            this.currentAnnouncement = {
                                id: announcement.id,
                                title: announcement.title,
                                subtitle: announcement.subtitle,
                                description: announcement.description,
                                imageUrl: announcement.imageUrl,
                                link: announcement.link,
                                linkText: announcement.linkText,
                                startDate: announcement.startDate,
                                endDate: announcement.endDate,
                            };

                            this.showAnnouncementModal = true;
                        }
                    }
                } catch (error) {
                    console.error("Error loading announcements:", error);
                }
            },
            OpenSystemNotificationsDialog() {
                this.GetAllSystemNotifications();
                this.SystemNotificationDialog = !this.SystemNotificationDialog
            },
            OpenPublicAnnouncementssDialog() {
                this.GetAllPublicAnnouncements();
                this.PublicAnnouncementsDialog = !this.PublicAnnouncementsDialog
            },
            MakeLatestPublicAnnouncementIsDismissed(announcementId) {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'SystemNotification/DismissLatestPublicAnnouncement?announcementId=' + announcementId)
                    .then(response => {
                        this.loadAnnouncements();
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            MakePublicAnnouncementIsDismissed(announcementId) {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'SystemNotification/DismissPublicAnnouncement?announcementId=' + announcementId)
                    .then(response => {
                        let index = this.publicAnnouncementsList.findIndex(i => i.id === announcementId);
                        if (index > -1)
                            this.publicAnnouncementsList.splice(index, 1);
                    })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            },
            openAnnouncementLink(announcement) {
                if (announcement && announcement.link) {
                    window.open(announcement.link, '_blank', 'noopener');
                    this.PublicAnnouncementsDialog = false;
                }
            },
            MakeSystemNotificationIsDismissed(item) {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsDismissed?SystemNotificationId=' + item.id)
                    .then(response => {
                        window.hideLoading();
                    })
                    .catch(error => console.log(error));

                this.systemNotificationList.splice(this.systemNotificationList.findIndex(i => i.id === item.id), 1)
            },
            openNotification(item) {
                window.showLoading();
                axios.get(constants.baseApiUrl + 'SystemNotification/SystemNotificationIsRead?SystemNotificationId=' + item.id)
                    .then(response => {
                        window.hideLoading()
                        let index = this.systemNotificationList.findIndex(i => i.id == item.id);
                        this.systemNotificationList[index].isRead = true;
                    })
                    .catch(error => console.log(error));

                this.OpenSystemNotification(item)
            },
            OpenSystemNotification(item) {
                this.correspondenceDialogObject.transferId = item.transferId;
                this.correspondenceDialogObject.documentId = item.documentId;
                this.correspondenceDialogOpened = true;
                this.SystemNotificationDialog = false;
            },
            OpenTaskNotification(item) {
                if (item.projectId != null && item.projectId != undefined && item.projectId > 0) {
                    this.taskDialogObject.projectId = item.projectId;
                    this.taskDialogObject.linkedWithProject = true;
                    this.taskDialogObject.isProjectCreator = false
                    this.taskDialogObject.isPublic = false;
                } else {
                    this.taskDialogObject.projectId = 0;
                    this.taskDialogObject.linkedWithProject = false;
                    this.taskDialogObject.isProjectCreator = false;
                    this.taskDialogObject.isPublic = false;
                }

                if (item.taskId != null && item.taskId != undefined && item.taskId > 0) {
                    this.taskDialogObject.selectedTaskId = item.taskId;
                    this.TaskDetailsDialogOpened = true;
                } else {
                    this.TaskProjecDialogOpened = true;
                }
                this.SystemNotificationDialog = false;
            },
            CloseCorrespondenceDialog() {
                this.correspondenceDialogObject.transferId = this.correspondenceDialogObject.documentId = this.correspondenceDialogObject.delegationId = 0;
                this.correspondenceDialogOpened = false;
            },
            startNotificationsTimer() {
                // Initial load of notifications
                this.GetAllSystemNotifications();
                // Setup SignalR connection for real-time updates
                this.setupSystemNotificationsSignalR();
            },
            clearNotificationsTimer() {
                // Stop SignalR connection
                if (this.systemNotificationsConnection) {
                    this.systemNotificationsConnection.stop()
                        .catch(err => console.error('Error stopping SignalR connection:', err));
                }
            },
            startPublicAnnouncementsTimer() {
                // Initial load of announcements
                this.GetAllPublicAnnouncements();
            },
            refreshPublicAnnouncements() {
                if (!this.enablePublicAnnouncements)
                    return;

                this.GetAllPublicAnnouncements();
                // don't replace an announcement the user is reading
                if (!this.showAnnouncementModal)
                    this.loadAnnouncements();
            },
            setupSystemNotificationsSignalR() {
                try {
                    const token = sessionStorage.getItem('jwt_token');
                    // Create SignalR connection
                    const connection = new signalR.HubConnectionBuilder()
                        .withUrl(constants.baseApiUrl.replace('api/', '') + 'systemNotificationHub', {
                            accessTokenFactory: () => token
                        })
                        .withAutomaticReconnect()
                        // default level is Information, which logs the hub url including the access token
                        .configureLogging(signalR.LogLevel.Error)
                        .build();

                    // Listen for new notification events from server
                    connection.on('SystemNotificationAdded', (notification) => {
                        this.GetAllSystemNotifications();
                    });

                    connection.on('SystemNotificationUpdated', (notification) => {
                        this.GetAllSystemNotifications();
                    });

                    // A transfer was received / read: refresh the sidebar badges.
                    connection.on('TransferCountsChanged', () => {
                        this.loadUnreadCounters();
                    });

                    // An admin added / updated / deleted a public announcement.
                    connection.on('PublicAnnouncementsChanged', () => {
                        this.refreshPublicAnnouncements();
                    });

                    // Events sent while the connection was down are lost, so resync on reconnect.
                    connection.onreconnected(() => {
                        this.GetAllSystemNotifications();
                        this.loadUnreadCounters();
                        this.refreshPublicAnnouncements();
                    });

                    connection.start()
                        .then(() => console.log('System Notifications SignalR connected'))
                        .catch(err => console.error('SignalR connection failed:', err));

                    // Store connection for cleanup
                    this.systemNotificationsConnection = connection;
                } catch (error) {
                    console.error('Error setting up system notifications SignalR:', error);
                }
            },
            addFloatingDisclaimer(msg) {
                const disclaimerDiv = document.createElement('div')
                disclaimerDiv.classList.add('floating-disclaimer')
                disclaimerDiv.innerHTML = msg
                disclaimerDiv.style.position = 'fixed'
                disclaimerDiv.style.top = '0'
                disclaimerDiv.style.left = '25%'
                disclaimerDiv.style.width = '50%'
                disclaimerDiv.style.background = 'rgba(255, 255, 255, 0.8)'
                disclaimerDiv.style.padding = '10px'
                disclaimerDiv.style.textAlign = 'center'
                disclaimerDiv.style.zIndex = '9999'
                disclaimerDiv.style.color = 'red'
                disclaimerDiv.style.fontSize = '16px'
                document.body.appendChild(disclaimerDiv)
            },
            setDefaultApplication(applicationId) {
                var userSettingsJSON = JSON.stringify({
                    defaultApplicationId: applicationId,
                    defaultPageUrl: "yourDefaultPageUrl"
                });

                document.cookie = "usersettings=" + encodeURIComponent(userSettingsJSON) + "; expires=Thu, 01 Jan 2099 00:00:00 UTC; path=/";

                if (applicationId == 1)
                    window.location.href = window.location.origin + "/inbox";
                else if (applicationId == 2)
                    window.location.href = window.location.origin + "/task";
                else if (applicationId == 3)
                    window.location.href = window.location.origin + "/meeting-mycalendar";
            },
            applyFilters(updatedFilters) {
                updatedFilters.subject = this.searchQuery;
                updatedFilters.referenceNumber = this.searchQuery;
                updatedFilters.enableAdvancedSearch = false;

                this.navigateAndSearch(updatedFilters);
            },
            navigateAndSearch(updatedFilters) {
                sessionStorage.setItem('advanced_search_filters', JSON.stringify(updatedFilters));
                router.push({ path: '/AdvancedSearch', query: { fromSession: true, r: new Date().getTime().toString() } })
            },
            changeSignaturePin() {
                this.openChangePinCode();
            },
            getUserDefaultSettings() {
                axios.get(constants.baseApiUrl + 'User/GetUserDefaultSettings')
                    .then(response => {
                        if (response.data != null && response.data) {
                            this.userDefaultSettings = {}
                            this.userDefaultSettings.seeOldLettersDefaultValue = response.data.seeOldLettersDefaultValue
                            this.userDefaultSettings.enableAutoDelegationfromHRMS = response.data.enableAutoDelegationfromHRMS
                            this.userDefaultSettings.enableProfileUpdatefromHRMS = response.data.enableProfileUpdatefromHRMS
                            this.otherSettingsDialog = true
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            saveUserDefaultSettings() {
                var body = {
                    seeOldLettersDefaultValue: this.userDefaultSettings.seeOldLettersDefaultValue,
                    enableAutoDelegationfromHRMS: this.userDefaultSettings.enableAutoDelegationfromHRMS,
                    enableProfileUpdatefromHRMS: this.userDefaultSettings.enableProfileUpdatefromHRMS
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + 'User/UpdateUserDefaultSettings', body)
                    .then(response => {
                        if (response.data != null && response.data) {
                            window.showAlert(this.translate("res_Msgs_UserDefaultSettingsUpdated"), 'success');
                            this.otherSettingsDialog = false;
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
            },
        },
        watch: {
            newCorrespondenceDialog: function (oldValue, newValue) {
                if (oldValue == false) {
                    window.location.reload();
                }
            },
            informationDialog: function (newValue, oldValue) {
                if (newValue == false) {
                    this.information_continueHandler = null
                    this.information_cancelHandler = null
                    this.information_showCancelButton = true
                    this.information_isHtml = false
                }
            },
        }
    }</script>

<style scoped>
    .blue-dot {
        width: 8px;
        height: 8px;
        background-color: #205cdf;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
    }

    .red-dot {
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        position: absolute;
        bottom: 18px;
        right: 5px;
    }

    .card-scroll {
        max-height: 400px;
        overflow-y: auto;
    }

    .profile-icons {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-around;
        text-decoration: none;
    }

    .profile-icons-container:hover {
        background-color: #eff2f5;
    }

    .expand-advance-search {
        padding: 0px 8px;
        margin: 0px 0px;
        border-radius: 4px;
        background-color: #698bb8;
    }

    .profileIconsCustom {
        text-align: center;
    }

        .profileIconsCustom .v-icon::before {
            font-size: 27px;
        }

    .mdi-icon-wrapper {
        padding: 7px;
        padding-bottom: 10px;
        background-color: #f4f6f8;
        cursor: pointer;
        border-radius: 5px;
        transition-duration: 0.5s;
    }

        .mdi-icon-wrapper:hover {
            background-color: #e4ebfb !important;
        }

    .cta-link-button {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #2a7f8f;
        color: white;
        text-decoration: none;
        font-weight: 500;
        padding: 12px 28px;
        border-radius: 50px;
        transition: all 0.3s ease;
        font-size: 15px;

        &:hover {
            background: #1f5a6f;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .arrow-icon {
            font-size: 18px;
            margin-left: 4px;
        }
    }

    /* Announcements Dialog Styles */
    .announcements-dialog {
        border-radius: 12px !important;
    }

    .announcements-card {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        background: white;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .announcements-header {
    }

    .announcements-title {
        font-size: 20px;
        color: #1a1a1a;
    }

    .announcements-empty {
        padding: 40px 24px;
        text-align: center;
        color: #999;
        background: white;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .announcements-list {
        max-height: 500px;
        overflow-y: auto;
        background: white;
        border-radius: 0 0 12px 12px;
        flex: 1;
        flex-shrink: 1;
        padding: 12px 0;
    }

    .announcement-item {
        background: linear-gradient(135deg, #d4ede6 0%, #c8f0ed 100%);
        border-radius: 12px;
        padding: 20px;
        display: flex;
        margin-top: 10px;
        align-items: flex-start;
        box-shadow: 0 2px 8px rgba(0, 138, 122, 0.08);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
    }

        .announcement-item:last-child {
            margin-bottom: 8px;
        }

        .announcement-item:hover {
            box-shadow: 0 8px 24px rgba(0, 138, 122, 0.15);
            transform: translateY(-4px);
            background: linear-gradient(135deg, #c8f0ed 0%, #b8ebe8 100%);
        }

    .announcement-content-box {
        flex: 1;
        padding-inline-end: 24px;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .announcement-item-title {
        font-size: 16px;
        font-weight: 600;
        font-weight: 700;
        margin: 0 0 10px 0;
        letter-spacing: -0.2px;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #1a1a1a;
    }

    .announcement-item-subtitle {
        font-size: 14px;
        color: #5a7a8a;
        margin: 0 0 12px 0;
        font-weight: 500;
        line-height: 1.5;
    }

    .announcement-btn {
        background: #008a7a !important;
        color: white !important;
        border-radius: 6px;
        padding: 10px 24px !important;
        text-transform: none !important;
        letter-spacing: normal !important;
        height: auto !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        white-space: nowrap;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(0, 138, 122, 0.2) !important;
    }

        .announcement-btn:hover {
            background: #006b5d !important;
            box-shadow: 0 6px 16px rgba(0, 138, 122, 0.35) !important;
            transform: translateY(-2px);
        }

    .announcement-item-close {
        position: absolute;
        top: 12px;
        inset-inline-end: 12px;
        cursor: pointer;
        color: #999;
        font-size: 20px;
        transition: all 0.2s ease;
        flex-shrink: 0;
    }

        .announcement-item-close:hover {
            color: #1a1a1a;
        }
</style>